import React from 'react';
import Head from 'next/head'
import { SeoItemInterface } from '../helper/PageInformationInterface';

export interface SeoProps {
  items: SeoItemInterface[]
}

export default function Seo(props: SeoProps) {
    return (
      <Head>
        { (props && props.items) && props.items.map(item => {
          if(item.property === "title") {
            return <React.Fragment key={`seo-title-key-${item.property}`}>
              <title key={`seo-title-${item.property}`}>{item.content}</title>
              <meta key={`seo-t-${item.property}`} name={item.property} content={item.content} />
            </React.Fragment>
          }
          else {
            return <React.Fragment key={`seo-key-${item.property}`}>
              <meta key={`seo-${item.property}`} name={item.property} content={item.content} />
              </React.Fragment>
          }
        })}
      </Head>
    );
}